import React,{useEffect,useState} from "react"
import {Form,Col} from 'react-bootstrap'

function YesNoNormal(props){
    const [normalDisabled,setNormalDisabled] = useState(true)
    const cleanNormal = ()=>{
        let e = {}
        e.name = props.name+"_normal"
        e.value=""
        props.handler(props.stateName,e)
    }
    const handleAnswer = (event) =>{
        if(event.target.value =="Yes"){
            setNormalDisabled(false)

        }
        else{
            setNormalDisabled(true)
            cleanNormal()
        }
        props.handler(props.stateName,event)
    }
    useEffect(()=>{
        if(props.data[props.name] =='Yes'){
            setNormalDisabled(false)
        }
    },[props.data[props.name]])
    return(
        <div>
           <Form>
               <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>{props.title}</Form.Label>
                        <Form.Control as={"select"} name={props.name} value={props.data[props.name]}onChange={handleAnswer} disabled={props.edit? true: false}>
                            <option></option>
                            <option>Yes</option>
                            <option>No</option>

                        </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label>Normal</Form.Label>
                        <Form.Control as={"select"} name={props.name+'_normal'} value={props.data[props.name+'_normal']} onChange={(event)=>props.handler(props.stateName,event)} disabled={props.edit? true :normalDisabled}>
                            <option></option>
                            <option>Yes</option>
                            <option>No</option>

                        </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label>Date</Form.Label>
                        <Form.Control name={props.name+'_date'} type={'date'} on value={props.data[props.name+'_date']} onChange={(event)=>props.handler(props.stateName,event)} disabled={props.edit? true :normalDisabled}/>
                    </Form.Group>
               </Form.Row>
           </Form>
        </div>
    )
}

export default YesNoNormal